const initialState = {
  name: null,
  id: null,
  // Гость: профиля нет, показан моковый (см. configs/guestProfile.js).
  // Настоящий вход этот признак снимает вместе с остальным профилем
  isGuest: false,
  numens: 0,
  crystals: 0,
  rating: 0,
  factionLoadouts: {},
  unitSkins: [],
  isNewItems: false,
  isAllFactionsAvailable: false,
  isAdmin: false,
  isSuperAdmin: false,
  // Видеомейкер: единственная привилегия — запись любого матча
  isVideoMaker: false,
  availableFactions: [],
  // Пароль есть только у аккаунтов, заведенных по почте: у гостя и у входа
  // через Яндекс ID менять нечего, кнопки смены пароля в настройках нет
  hasPassword: false,
  hasAcceptedPrivacyPolicy: false,
  friendReferalCode: null,
  hasAcceptedLicenseAgreement: false,
  // Подтвердил ли пользователь, что ему исполнилось 18 лет (экран согласия)
  hasConfirmedAdult: false,
  hasSeenIntroSlides: false,
  // Закрыта ли новость о рейтинговых обличиях в меню (один раз на аккаунт).
  // null — неизвестно: новость показывается только при явном false
  hasSeenRankSkinsNews: null,
  hasSeenAiMatchNews: null,
  // Игрок закрыл прежнюю редакцию анонса «Битвы с AI Claude Opus»: текущая
  // для него — известие о новом времени матча (см. aiMatchNewsVersion.js)
  isAiMatchNewsUpdate: false,
  isAiPromoAvailable: false,
  // Момент последнего получения двойной (x2) награды за первый рейтинговый
  // матч игрового дня (ISO-строка/Date, null — не получал). Доступность
  // награды клиент вычисляет сам сравнением с текущими игровыми сутками
  // (useIsDailyDoubleRewardAvailable) — так бейдж корректно зажигается после
  // полуночи даже на давно открытой странице
  lastDoubleRewardAt: null,
  // Ежедневная награда за вход: момент последнего получения (сырая дата, тот
  // же принцип клиентского сравнения игровых суток) и счетчик дней подряд
  dailyLoginRewardClaimedAt: null,
  dailyLoginRewardStreak: 0,
  // Дата истечения премиума (сырая дата, null — премиума не было). Активность
  // клиент вычисляет сравнением с текущим моментом на каждом рендере
  premiumExpiresAt: null,
  // Партнерская программа: признак активного партнера (кнопка «Партнерка») и
  // реферальная привязка (модалка реферальной награды: показывается, пока
  // hasReceivedPartnerReferalRewards === false)
  isActivePartner: false,
  linkedToPartnerReferalId: null,
  hasReceivedPartnerReferalRewards: null,
  // «Пригласи друга»: привязка к пригласившему (модалка реферальной награды
  // показывается, пока hasReceivedFriendReferalRewards === false)
  referredByUserId: null,
  hasReceivedFriendReferalRewards: null,
  // Акции за вход: id акций, награду по которым пользователь уже забрал
  claimedLoginPromoIds: [],
  // Разовые подарки за интерес к покупке премиума/кристаллов: типы товаров,
  // по которым подарок уже выдан (см. configs/purchaseInterestRewards.js)
  receivedPurchaseInterestRewards: [],
  // Награда за первый вход через установленное приложение: дата начисления,
  // null — еще не начислялась (главное меню по ней решает, просить ли ее у
  // сервера, см. utils/pwa/appInstall)
  appInstallRewardGrantedAt: null,
  // Обучение: id пройденных глав (последовательная разблокировка миссий,
  // превращение кнопки «Обучение» в «Сюжетная кампания»)
  completedTutorialChapters: [],
  // Пройденные миссии сюжетных кампаний (см. src/configs/campaigns)
  completedCampaignMissions: [],
  // Задания (src/configs/quests.js): id выполненных. Задания глав обучения
  // сюда НЕ пишутся — их выполненность берется из completedTutorialChapters
  completedQuests: [],
  // Сыгранные сетевые матчи — рейтинговые и обычные, без локальных против
  // ботов и глав обучения (см. onlineGamesPlayed в server/models/User.js), и
  // из них рейтинговые. Отдельно — локальные партии против ботов. null —
  // счетчик неизвестен (гость, старый сервер): по ним главное меню ведет
  // новичка по воронке — бой с ботами, обычный матч, рейтинг (см.
  // utils/menuPromo)
  localGamesPlayed: null,
  onlineGamesPlayed: null,
  rankedGamesPlayed: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_COMPLETED_CAMPAIGN_MISSIONS':
      return {
        ...state,
        completedCampaignMissions: action.payload.completedCampaignMissions ?? [],
      };

    case 'SET_COMPLETED_TUTORIAL_CHAPTERS':
      return {
        ...state,
        completedTutorialChapters: action.payload.completedTutorialChapters ?? [],
        appInstallRewardGrantedAt: action.payload.appInstallRewardGrantedAt ?? null,
        completedCampaignMissions: action.payload.completedCampaignMissions ?? [],
      };

    case 'ADD_COMPLETED_QUEST': {
      const questId = action.payload.questId;
      if (!questId || state.completedQuests.includes(questId)) {
        return state;
      }
      return {
        ...state,
        completedQuests: [...state.completedQuests, questId],
      };
    }

    case 'SET_PLAYER_AUTH':
      return {
        ...state,
        name: action.payload.name,
        id: action.payload.id,
        isGuest: action.payload.isGuest ?? false,
        numens: action.payload.numens ?? 0,
        crystals: action.payload.crystals ?? 0,
        rating: action.payload.rating ?? 0,
        factionLoadouts: action.payload.factionLoadouts ?? {},
        unitSkins: action.payload.unitSkins ?? [],
        isNewItems: action.payload.isNewItems ?? false,
        isAllFactionsAvailable: action.payload.isAllFactionsAvailable ?? false,
        isAdmin: action.payload.isAdmin ?? false,
        isSuperAdmin: action.payload.isSuperAdmin ?? false,
        isVideoMaker: action.payload.isVideoMaker ?? false,
        // Пароль есть только у аккаунтов, заведенных по почте (см. hasPassword
        // в /auth/me): по нему настройки показывают смену пароля
        hasPassword: action.payload.hasPassword ?? false,
        hasAcceptedPrivacyPolicy: action.payload.hasAcceptedPrivacyPolicy ?? false,
        hasAcceptedLicenseAgreement: action.payload.hasAcceptedLicenseAgreement ?? false,
        hasConfirmedAdult: action.payload.hasConfirmedAdult ?? false,
        hasSeenIntroSlides: action.payload.hasSeenIntroSlides ?? false,
        // Отметка, поставленная по клику в этой сессии, не откатывается
        // профилем того же игрока, пришедшим раньше, чем сервер ее записал
        // (например, /auth/me при возврате на вкладку)
        hasSeenRankSkinsNews: (state.hasSeenRankSkinsNews === true && state.id && state.id === action.payload.id)
          ? true
          : (action.payload.hasSeenRankSkinsNews ?? null),
        // Анонс «Битвы с AI Claude Opus» — так же: отметка по клику липкая
        hasSeenAiMatchNews: (state.hasSeenAiMatchNews === true && state.id && state.id === action.payload.id)
          ? true
          : (action.payload.hasSeenAiMatchNews ?? null),
        isAiMatchNewsUpdate: action.payload.isAiMatchNewsUpdate ?? false,
        isAiPromoAvailable: action.payload.isAiPromoAvailable ?? false,
        lastDoubleRewardAt: action.payload.lastDoubleRewardAt ?? null,
        dailyLoginRewardClaimedAt: action.payload.dailyLoginRewardClaimedAt ?? null,
        dailyLoginRewardStreak: action.payload.dailyLoginRewardStreak ?? 0,
        premiumExpiresAt: action.payload.premiumExpiresAt ?? null,
        isActivePartner: action.payload.isActivePartner ?? false,
        linkedToPartnerReferalId: action.payload.linkedToPartnerReferalId ?? null,
        hasReceivedPartnerReferalRewards: action.payload.hasReceivedPartnerReferalRewards ?? null,
        // Публичный код для реферальных ссылок — им, а не id игрока,
        // адресуются приглашения (см. buildLobbyInviteUrl)
        friendReferalCode: action.payload.friendReferalCode ?? null,
        referredByUserId: action.payload.referredByUserId ?? null,
        hasReceivedFriendReferalRewards: action.payload.hasReceivedFriendReferalRewards ?? null,
        claimedLoginPromoIds: action.payload.claimedLoginPromoIds ?? [],
        receivedPurchaseInterestRewards: action.payload.receivedPurchaseInterestRewards ?? [],
        completedTutorialChapters: action.payload.completedTutorialChapters ?? [],
        appInstallRewardGrantedAt: action.payload.appInstallRewardGrantedAt ?? null,
        completedCampaignMissions: action.payload.completedCampaignMissions ?? [],
        completedQuests: action.payload.completedQuests ?? [],
        localGamesPlayed: action.payload.localGamesPlayed ?? null,
        onlineGamesPlayed: action.payload.onlineGamesPlayed ?? null,
        rankedGamesPlayed: action.payload.rankedGamesPlayed ?? null,
      };
    case 'UPDATE_PLAYER_REWARDS': {
      const updates = {
        numens: (state.numens || 0) + (action.payload.numensDelta || 0),
        crystals: (state.crystals || 0) + (action.payload.crystalsDelta || 0),
      };
      if (action.payload.rating !== undefined) {
        updates.rating = action.payload.rating;
      }
      if (action.payload.isNewItems !== undefined) {
        updates.isNewItems = action.payload.isNewItems;
      }
      // Пользователь только что получил x2 за первый матч дня — бейдж
      // «награда x2» в главном меню гаснет до следующих игровых суток
      // (момент проставляет экшен-криэйтор, см. updatePlayerRewards)
      if (action.payload.doubleRewardClaimedAt) {
        updates.lastDoubleRewardAt = action.payload.doubleRewardClaimedAt;
      }
      return {...state, ...updates};
    }
    case 'SET_DAILY_LOGIN_REWARD_CLAIMED':
      return {
        ...state,
        dailyLoginRewardClaimedAt: action.payload.claimedAt,
        dailyLoginRewardStreak: action.payload.streak,
      };
    case 'INCREMENT_LOCAL_GAMES_PLAYED': {
      // null означает «счетчик неизвестен» (старый сервер) — таким и остается
      return {
        ...state,
        localGamesPlayed: typeof state.localGamesPlayed === 'number' ? state.localGamesPlayed + 1 : null,
      };
    }
    case 'SYNC_LOCAL_GAMES_PLAYED': {
      const serverValue = action.payload.localGamesPlayed;
      if (!Number.isInteger(serverValue) || serverValue < 0) {
        return state;
      }
      // Счетчик только растет: ответ, пришедший с опозданием (сохранение
      // прошлой партии дошло позже следующей), назад его не откатывает
      if (typeof state.localGamesPlayed === 'number' && state.localGamesPlayed >= serverValue) {
        return state;
      }
      return {...state, localGamesPlayed: serverValue};
    }
    case 'INCREMENT_ONLINE_GAMES_PLAYED': {
      // null означает «счетчик неизвестен» (старый сервер) — таким и остается
      const increment = (value) => (typeof value === 'number' ? value + 1 : null);
      return {
        ...state,
        onlineGamesPlayed: increment(state.onlineGamesPlayed),
        rankedGamesPlayed: action.payload?.isRanked ? increment(state.rankedGamesPlayed) : state.rankedGamesPlayed,
      };
    }
    case 'SET_PREMIUM_EXPIRES_AT':
      // Премиум выпал из сундука и уже начислен сервером — обновляем дату в
      // профиле без рефетча /me (активность премиума клиент вычисляет из нее
      // сам на каждом рендере, см. UserHeader)
      return {
        ...state,
        premiumExpiresAt: action.payload.premiumExpiresAt ?? state.premiumExpiresAt,
      };
    case 'APPLY_PARTNER_REFERAL_REWARDS_CLAIM':
      // Балансы и премиум приходят с сервера уже начисленными; предметы
      // инвентаря клиент отдельно не хранит — достаточно бейджа isNewItems.
      // Бейдж зажигается только по hasNewItems (в наградах были предметы
      // коллекции) и НИКОГДА не гасится здесь: уже стоявший флаг от прежних
      // начислений должен пережить награду из одних валют
      return {
        ...state,
        numens: action.payload.numens ?? state.numens,
        crystals: action.payload.crystals ?? state.crystals,
        premiumExpiresAt: action.payload.premiumExpiresAt ?? state.premiumExpiresAt,
        isNewItems: action.payload.hasNewItems ? true : state.isNewItems,
        hasReceivedPartnerReferalRewards: true,
      };
    case 'APPLY_PURCHASE_INTEREST_REWARD_CLAIM':
      // Балансы (кристаллы) и премиум приходят с сервера уже начисленными;
      // тип товара запоминается, чтобы подарок не предлагался повторно
      return {
        ...state,
        numens: action.payload.numens ?? state.numens,
        crystals: action.payload.crystals ?? state.crystals,
        premiumExpiresAt: action.payload.premiumExpiresAt ?? state.premiumExpiresAt,
        receivedPurchaseInterestRewards: action.payload.purchaseType
        && !state.receivedPurchaseInterestRewards.includes(action.payload.purchaseType)
          ? [...state.receivedPurchaseInterestRewards, action.payload.purchaseType]
          : state.receivedPurchaseInterestRewards,
      };
    case 'SET_RANK_SKINS_NEWS_SEEN':
      return {
        ...state,
        hasSeenRankSkinsNews: true,
      };
    case 'SET_AI_MATCH_NEWS_SEEN':
      return {
        ...state,
        hasSeenAiMatchNews: true,
      };
    case 'APPLY_APP_INSTALL_REWARD_GRANTED':
      return {
        ...state,
        appInstallRewardGrantedAt: action.payload.grantedAt ?? new Date().toISOString(),
        // Сундук уже в коллекции — она непросмотрена, как после любой награды
        isNewItems: true,
      };
    case 'APPLY_FRIEND_REFERAL_REWARDS_CLAIM':
      return {
        ...state,
        numens: action.payload.numens ?? state.numens,
        crystals: action.payload.crystals ?? state.crystals,
        premiumExpiresAt: action.payload.premiumExpiresAt ?? state.premiumExpiresAt,
        isNewItems: action.payload.hasNewItems ? true : state.isNewItems,
        hasReceivedFriendReferalRewards: true,
      };
    case 'APPLY_LOGIN_PROMO_REWARDS_CLAIM':
      // Баланс и премиум приходят с сервера уже начисленными; id акции
      // дописывается в список полученных, чтобы модалка больше не всплывала
      return {
        ...state,
        numens: action.payload.numens ?? state.numens,
        crystals: action.payload.crystals ?? state.crystals,
        premiumExpiresAt: action.payload.premiumExpiresAt ?? state.premiumExpiresAt,
        isNewItems: action.payload.hasNewItems ? true : state.isNewItems,
        claimedLoginPromoIds: action.payload.promoId
        && !state.claimedLoginPromoIds.includes(action.payload.promoId)
          ? [...state.claimedLoginPromoIds, action.payload.promoId]
          : state.claimedLoginPromoIds,
      };
    case 'UPDATE_FACTION_LOADOUT': {
      const {factionId, loadout} = action.payload;
      return {
        ...state,
        factionLoadouts: {
          ...state.factionLoadouts,
          [factionId]: {
            ...state.factionLoadouts[factionId],
            ...loadout,
          },
        },
      };
    }
    case 'CLEAR_FACTION_SKIN_SELECTION': {
      const {factionId} = action.payload;
      const factionLoadouts = {...state.factionLoadouts};
      const factionLoadout = {...factionLoadouts[factionId]};
      delete factionLoadout.selectedSkin;
      if (Object.keys(factionLoadout).length === 0) {
        delete factionLoadouts[factionId];
      } else {
        factionLoadouts[factionId] = factionLoadout;
      }
      return {...state, factionLoadouts};
    }
    case 'ADD_OWNED_UNIT_SKIN': {
      const {unitSkinId} = action.payload;
      if (state.unitSkins.includes(unitSkinId)) return state;
      return {...state, unitSkins: [...state.unitSkins, unitSkinId]};
    }
    case 'SET_AVAILABLE_FACTIONS':
      return {...state, availableFactions: action.payload || []};
    case 'SET_IS_ALL_FACTIONS_AVAILABLE':
      return {...state, isAllFactionsAvailable: Boolean(action.payload)};
    case 'CLEAR_PLAYER_AUTH':
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
